import React, { FC, useCallback, useMemo } from 'react';
import { UseFormReturn } from 'react-hook-form';

import { useLocalforage } from '@hooks';
import { BasicTable } from '@ui';
import { LocalForageKey, Preset } from 'types';
import { TableActionButton } from './TableActionButton';

type PresetTableTableProps = {
	formControls: UseFormReturn<Preset, unknown, Preset>;
};

/**
 * Bảng hiển thị danh sách preset trong popup tạo
 */
const PresetTable: FC<PresetTableTableProps> = ({ formControls }) => {
	const { reset } = formControls;
	const [presetData, setPresetData] = useLocalforage<Preset[]>(LocalForageKey['Preset'], []);

	/**
	 * Set value of row to form
	 */
	const onRowClick = useCallback(
		(value: Preset) => {
			reset(value);
		},
		[reset],
	);

	const onChangeIndex = useCallback(
		async (index: number, upper: boolean) => {
			const newIndex = index + (upper ? -1 : 1);
			const currentPresets = [...(presetData ?? [])];
			const preset = currentPresets[index];
			currentPresets.splice(index, 1);
			currentPresets.splice(newIndex, 0, preset);
			await setPresetData(currentPresets);
		},
		[presetData, setPresetData],
	);

	const deletePreset = useCallback(
		async (index: number) => {
			const currentPresets = [...(presetData ?? [])];
			currentPresets.splice(index, 1);
			await setPresetData(currentPresets);
		},
		[presetData, setPresetData],
	);

	const columns = useMemo(
		() => [
			{
				accessorKey: 'name',
				header: 'Preset Name',
				size: 30,
				cell: (cell) => <>{cell.getValue()}</>,
			},
			{
				accessorKey: 'modality',
				header: 'Modality',
				size: 20,
				cell: (cell) => <>{cell.getValue()}</>,
			},
			{
				accessorKey: 'ww',
				header: 'WW',
				size: 20,
				cell: (cell) => <>{cell.getValue()}</>,
			},
			{
				accessorKey: 'wl',
				header: 'WL',
				size: 20,
				cell: (cell) => <>{cell.getValue()}</>,
			},
			{
				header: ' ',
				accessorKey: 'actions',
				size: 40,
				cell: (cell) => {
					return (
						<TableActionButton
							numOfPreset={presetData.length}
							onChangeIndex={onChangeIndex}
							deletePreset={deletePreset}
							index={cell.rowIndex}
						/>
					);
				},
			},
		],
		[deletePreset, onChangeIndex, presetData.length],
	);
	return (
		<div className="grow overflow-auto">
			<BasicTable data={presetData} columns={columns} onRowClick={onRowClick} />
		</div>
	);
};

export default PresetTable;
